// extracted by mini-css-extract-plugin
export default {"breadcrumb-container":"breadcrumbs__breadcrumb-container___M8l_F","breadcrumb-link":"breadcrumbs__breadcrumb-link___aIP80"};